function NextQuestion(props) {
  return (
    <div>
      <button onClick={props.goToNextQuestion}>Next Question</button>
      <p>Q{props.currentQuestionNum + 1}</p>
    </div>
  );
}

export default NextQuestion;
